// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {environmentConfig} from './model';
import {Platform} from '../core/models/platform.enum';

export const environment: environmentConfig = {
  android: false,
  iOS: false,
  production: false,
  apiUrl: 'https://api.dev.motn.io',
  wsUrl: 'wss://api.dev.motn.io',
  // wsUrl: 'ws://local.motion.cloud:8080',
  convoUrl: 'https://api.dev.motn.io',
  tunnelUrl: 'https://api.dev.motn.io',
  // convoUrl: 'http://local.motion.cloud:8080',
  // tunnelUrl: 'http://local.motion.cloud:8080',
  fileUploadUrl: 'https://api.dev.motn.io',
  platform: Platform.WEB,
  storeUrl: null,
};

// export const environment: environmentConfig = {
//   android: false,
//   iOS: false,
//   production: false,
//   apiUrl: 'https://api.motion.cloud',
//   convoUrl: 'https://api.motion.cloud',
//   wsUrl: 'https://api.motion.cloud',
//   tunnelUrl: 'https://api.motion.cloud',
//   fileUploadUrl: 'https://api.motion.cloud',
//   platform: Platform.WEB,
//   storeUrl: null,
// };

// https://api.dev.motn.io
